import "./styles.scss";

import classnames from "classnames";

import Menu from "./components/Menu";

import { useApp } from "context/app";

const mainClass = "dashboard-layout-sidebar";

const Sidebar = () => {
  const { sidebar_open, setSidebarOpen } = useApp();

  return (
    <>
      <div
        className={classnames(mainClass, {
          [`${mainClass}--open`]: sidebar_open,
        })}
      >
        <Menu setSidebarOpen={setSidebarOpen} />
      </div>
      <button
        className={classnames(`${mainClass}__overlay`, {
          [`${mainClass}__overlay--open`]: sidebar_open,
        })}
        onClick={() => setSidebarOpen(false)}
        aria-label="Close sidebar"
      />
    </>
  );
};

export default Sidebar;
